<!--
 * @Description: 会场详情
 * @Autor: kangpeng
 * @Date: 2020-04-21 16:46:36
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-06-15 18:00:57
 -->
<template>
    <div class="venue_detail_wrap">
        <div class="breadcrumb_wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{venueDetailData.storeName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="top_main_info">
            <div class="swiper_wrap">
                <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                    <swiper-slide v-for="(item,index) in venueDetailData.urls" :key="index">
                        <img class="slide_big" :src="`${item}?x-oss-process=style/watermark`" alt />
                    </swiper-slide>
                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                </swiper>
                <swiper
                    class="swiper gallery-thumbs"
                    :options="swiperOptionThumbs"
                    ref="swiperThumbs"
                >
                    <swiper-slide v-for="(item,index) in venueDetailData.urls" :key="index">
                        <img class="slide_small" :src="`${item}?x-oss-process=style/watermark`" alt />
                    </swiper-slide>
                </swiper>
            </div>
            <div class="desc_info">
                <div class="tags">
                    <span v-show="venueDetailData.isDiscount" class="discount">优惠</span>
                    <span v-show="venueDetailData.isVerification" class="checked">认证会场</span>
                    <span class="txt">{{venueDetailData.storeName}}</span>
                    <span class="unique">[{{venueDetailData.type || '其他'}}]</span>
                </div>

                <div class="icons">
                    <ul class="list">
                        <li class="item">
                            <div class="item_inner">
                                <img src="../../assets/img/venuedetail_img/meeting.png" alt />
                                <span class="middle">{{venueDetailData.fieldCount || '--'}}间</span>
                                <span class="last">会场数量</span>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item_inner">
                                <img src="../../assets/img/venuedetail_img/area.png" alt />
                                <span class="middle">{{venueDetailData.area || '--'}}</span>
                                <span class="last">会场面积</span>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item_inner">
                                <img src="../../assets/img/venuedetail_img/num.png" alt />
                                <span class="middle">{{venueDetailData.capacity || '--'}}人</span>
                                <span class="last">容纳人数</span>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item_inner">
                                <img src="../../assets/img/venuedetail_img/price.png" alt />
                                <span
                                    class="middle"
                                >{{venueDetailData.minPrice ? (venueDetailData.minPrice == '面议' ? '面议':`￥${venueDetailData.minPrice}` ) : '--'}}</span>
                                <span class="last">市场价格</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="special_tag">
                    <span class="title">会场特色 :</span>
                    <div class="tag_list">
                        <span
                            class="tag"
                            v-for="(tag,index) in venueDetailData.tag.split(',')"
                            :key="index"
                        >{{tag}}</span>
                    </div>
                </div>
                <div class="address_wrap">
                    <div class="address">
                        <img src="../../assets/img/venuedetail_img/address.png" alt />
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="venueDetailData.address"
                            placement="top"
                        >
                            <span>{{venueDetailData.address | ellipsis(40)}}</span>
                        </el-tooltip>
                    </div>
                    <div class="send" @click="handleToBaiduMap(venueDetailData)">
                        <img src="../../assets/img/venuedetail_img/map.png" alt />
                        <span class="send_txt">在地图上查看</span>
                    </div>
                </div>
                <div class="phone">
                    <span class="label">总机：</span>
                    <span style="font-weight:bold" class="value">0755-86969257</span>
                </div>
            </div>
        </div>
        <div class="tabs_wrap">
            <ul class="list">
                <li
                    class="item"
                    :class="currActive == index ? 'active' : ''"
                    v-for="(item,index) in tabsList"
                    :key="index"
                >
                    <a :href="item.href" @click="handleChange(index)">{{item.name}}</a>
                </li>
            </ul>
            <div id="meeting_info_wrap">
                <div class="meeting_info">
                    <span class="title">会议档期信息</span>
                </div>
                <div class="list_wrap">
                    <div class="header">
                        <span class="item">会议室名称</span>
                        <span class="item">面积(㎡)</span>
                        <span class="item">最多容纳人数</span>
                        <div class="special">
                            <span class="name">会议室布局及容纳人数</span>
                            <span class="pics">
                                <img
                                    class="item"
                                    :src="item"
                                    alt
                                    v-for="(item,index) in picsList"
                                    :key="index"
                                />
                            </span>
                        </div>
                        <span class="item">会议价格(元)</span>
                        <span class="item">档期</span>
                    </div>
                    <div class="data_wrap">
                        <div
                            style="border-bottom:1px dashed #ddd"
                            v-for="(item,index) in venueDetailData.fieldList.slice(0,3)"
                            :key="index"
                        >
                            <div class="col" v-if="index<=3">
                                <div class="item first" @click="item.currStatus = !item.currStatus">
                                    <div>
                                        <span>{{item.fieldName | ellipsis(12)}}</span>
                                        <i
                                            :class="item.currStatus ? 'el-icon-caret-top':'el-icon-caret-bottom'"
                                        ></i>
                                    </div>
                                </div>
                                <span class="item">{{item.area}}</span>
                                <span class="item">{{item.capacity}}</span>
                                <div class="special">
                                    <span class="pics">
                                        <span class="item">{{item.jysLayout}}</span>
                                        <span class="item">{{item.kzsLayout}}</span>
                                        <span class="item">{{item.yhsLayout}}</span>
                                        <span class="item">{{item.uzxLayout}}</span>
                                        <span class="item">{{item.fzsLayout}}</span>
                                        <span class="item">{{item.hzxLayout}}</span>
                                        <span class="item">{{item.jhsLayout}}</span>
                                    </span>
                                </div>
                                <span class="item" style="color:#ff5722">{{item.minPrice || '面议'}}</span>
                                <span class="item">
                                    <el-button
                                        size="mini"
                                        type="warning"
                                        @click="handleOpenCalendar(item)"
                                    >免费看档期</el-button>
                                </span>
                            </div>
                            <div>
                                <el-collapse-transition>
                                    <div v-show="item.currStatus">
                                        <swiper
                                            style="height:150px"
                                            class="swiper"
                                            :options="swiperOption"
                                        >
                                            <swiper-slide
                                                class="swiper-slide"
                                                v-for="(pic,index) in item.urls"
                                                :key="index"
                                            >
                                                <img
                                                    :src="`${pic}?x-oss-process=style/watermark`"
                                                    alt
                                                />
                                            </swiper-slide>
                                            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
                                            <div class="swiper-button-prev" slot="button-prev"></div>
                                            <div class="swiper-button-next" slot="button-next"></div>
                                        </swiper>
                                    </div>
                                </el-collapse-transition>
                            </div>
                        </div>
                        <div class="rest_data">
                            <el-collapse-transition>
                                <div v-show="isShowRest">
                                    <div
                                        style="border-bottom:1px dashed #ddd"
                                        v-for="(item,index) in venueDetailData.fieldList.slice(3)"
                                        :key="index"
                                    >
                                        <div class="col">
                                            <div
                                                class="item first"
                                                @click="item.currStatus = !item.currStatus"
                                            >
                                                <div>
                                                    <span>{{item.fieldName | ellipsis(12)}}</span>
                                                    <i
                                                        :class="item.currStatus ? 'el-icon-caret-top':'el-icon-caret-bottom'"
                                                    ></i>
                                                </div>
                                            </div>
                                            <span class="item">{{item.area}}</span>
                                            <span class="item">{{item.capacity}}</span>
                                            <div class="special">
                                                <span class="pics">
                                                    <span class="item">{{item.jysLayout}}</span>
                                                    <span class="item">{{item.kzsLayout}}</span>
                                                    <span class="item">{{item.yhsLayout}}</span>
                                                    <span class="item">{{item.uzxLayout}}</span>
                                                    <span class="item">{{item.fzsLayout}}</span>
                                                    <span class="item">{{item.hzxLayout}}</span>
                                                    <span class="item">{{item.jhsLayout}}</span>
                                                </span>
                                            </div>
                                            <span
                                                class="item"
                                                style="color:#ff5722"
                                            >{{item.minPrice || '面议'}}</span>
                                            <span class="item">
                                                <el-button
                                                    size="mini"
                                                    type="warning"
                                                    @click="handleOpenCalendar(item)"
                                                >免费看档期</el-button>
                                            </span>
                                        </div>
                                        <div>
                                            <el-collapse-transition>
                                                <div v-show="item.currStatus">
                                                    <swiper
                                                        style="height:150px"
                                                        class="swiper"
                                                        :options="swiperOption"
                                                    >
                                                        <swiper-slide
                                                            v-for="(pic,index) in item.urls"
                                                            :key="index"
                                                        >
                                                            <img
                                                                style="height:100px"
                                                                :src="`${pic}?x-oss-process=style/watermark`"
                                                                alt
                                                            />
                                                        </swiper-slide>
                                                        <div
                                                            class="swiper-pagination"
                                                            slot="pagination"
                                                        ></div>
                                                        <div
                                                            class="swiper-button-prev"
                                                            slot="button-prev"
                                                        ></div>
                                                        <div
                                                            class="swiper-button-next"
                                                            slot="button-next"
                                                        ></div>
                                                    </swiper>
                                                </div>
                                            </el-collapse-transition>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-transition>
                        </div>
                        <div class="load_rest" v-show="venueDetailData.fieldList.length > 3">
                            <span @click="isShowRest = !isShowRest">
                                {{isShowRest ? '收起会议室信息' : `展开其他${venueDetailData.fieldList.length - 3 || 0}个会议室` }}
                                <i
                                    :class="isShowRest ? 'el-icon-arrow-up':'el-icon-arrow-down'"
                                ></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div id="meeting_introduct_wrap">
                <div class="meeting_introduct">
                    <span class="title">会议简介</span>
                </div>
                <div class="txt_box">
                    <span @click="introduceStatus = !introduceStatus" class="position">
                        {{introduceStatus ? '收起' :'展开'}}
                        <i
                            :class="introduceStatus ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                        ></i>
                    </span>
                    <span
                        v-if="!introduceStatus"
                        class="txt"
                    >{{venueDetailData.description | ellipsis(300)}}</span>
                    <span v-else class="txt">{{venueDetailData.description}}</span>
                </div>
            </div>
            <div id="equipment_wrap">
                <div class="equipment">
                    <span class="title">配套设施</span>
                </div>
                <div class="list_wrap" v-if="venueDetailData.siteList.length">
                    <ul class="list">
                        <li
                            class="item"
                            v-for="(facilities,index) in venueDetailData.siteList"
                            :key="index"
                        >
                            <span
                                class="title"
                                v-show="facilities.list.length >0"
                            >{{getType(facilities.type)}}</span>
                            <div class="pic_list_wrap">
                                <ul class="pic_list">
                                    <li
                                        class="pic_item"
                                        v-for="(item,index) in facilities.list"
                                        :key="index"
                                    >
                                        <img class="pic" :src="item.icon" alt />
                                        <span class="name">{{item.name}}</span>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-else>
                    <span style="margin-left:30px;color:#666;font-size:14px">暂无</span>
                </div>
            </div>
        </div>
        <el-dialog
            v-if="fileldDate"
            :title="currFieldName"
            :visible.sync="isOpenCalendar"
            width="830px"
            :before-close="cleanData"
        >
            <el-calendar>
                <template slot="dateCell" slot-scope="{date, data}">
                    <!-- 时间过期 -->
                    <div
                        v-show="getShowDate(date,data) === 'is_expire'"
                        class="expire_date calendar_cell"
                    >
                        <span class="is_expire_desc"></span>
                        <span
                            :class="getToday(data) === '今天' ? 'is_today' : 'is_expire_date'"
                        >{{ getToday(data) }}</span>
                    </div>
                    <!-- 开放时间 -->
                    <div
                        v-show="getShowDate(date,data) === 'is_open'"
                        class="open_date calendar_cell"
                    >
                        <span
                            :class="getToday(data) === '今天' ? 'is_today' : 'is_open_date'"
                        >{{ getToday(data) }}</span>
                        <span class="is_open_desc">￥{{fileldDate.amount}}</span>
                    </div>
                    <!-- 开放时间中已订 -->
                    <div
                        v-show="getShowDate(date,data) === 'is_order'"
                        class="order_date calendar_cell"
                    >
                        <span class="is_order_desc">已订</span>
                        <span
                            :class="getToday(data) === '今天' ? 'is_today_order' : 'is_order_date'"
                        >{{ getToday(data) }}</span>
                    </div>
                    <!-- 开放时间中低价 -->
                    <div v-show="getShowDate(date,data) === 'is_cheap'" class="cheap_date">
                        <div class="cheap_box_top">
                            <span class="is_cheap_desc"></span>
                            <span
                                :class="getToday(data) === '今天' ? 'is_today' : 'is_cheap_date'"
                            >{{ getToday(data) }}</span>
                        </div>
                        <div class="cheap_box_bottom">
                            <span class="cheap_price">￥{{getCheapPrice(data)}}</span>
                            <span class="cheap_num">
                                <i class="iconfont icon-yly_xiajiang"></i>
                                {{fileldDate.amount - getCheapPrice(data)}}
                            </span>
                        </div>
                    </div>
                    <!-- 开放时间中高价 -->
                    <div
                        v-show="getShowDate(date,data) === 'is_expensive'"
                        class="open_date calendar_cell"
                    >
                        <span
                            :class="getToday(data) === '今天' ? 'is_today' : 'is_expensive_date'"
                        >{{ getToday(data) }}</span>
                        <span class=".is_expensive_desc">￥{{getHightPrice(data)}}</span>
                    </div>
                    <!-- 未开放时间 -->
                    <div
                        v-show="getShowDate(date,data) === 'is_not_open'"
                        class="not_open_date calendar_cell"
                    >
                        <span class="is_not_open_desc"></span>
                        <span class="is_not_open_date">{{ getToday(data) }}</span>
                    </div>
                </template>
            </el-calendar>
            <span slot="footer" class="dialog-footer">
                <div class="tips_box">
                    <span style="color:red">*</span>
                    <span>会场价格可能随市场波动，以实际成交价格为准。</span>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            swiperOption: {
                slidesPerView: 6,
                spaceBetween: 0,
                slidesPerGroup: 6,
                loop: true,
                loopFillGroupWithBlank: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            swiperOptionTop: {
                loop: true,
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            swiperOptionThumbs: {
                loop: true,
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
                slideToClickedSlide: true
            },
            currActive: 0,
            currStatus: false,
            isShowRest: false,
            introduceStatus: false,
            venueDetailData: {},
            isOpenCalendar: false,
            fileldDate: null,
            isShowDate: false,
            cheapDateList: [],
            hightDateList: [],
            endDate: null,
            todayDate: new Date(),
            tabsList: [
                {
                    name: "会议档期信息",
                    href: "#meeting_info_wrap"
                },
                {
                    name: "会议简介",
                    href: "#meeting_introduct_wrap"
                },
                {
                    name: "配套设施",
                    href: "#equipment_wrap"
                }
                // {
                //     name: "会场口碑",
                //     href: ""
                // }
            ],
            titleList: [
                "会议室名称",
                "面积(㎡)",
                "最多容纳人数",
                "会议室布局及容纳人数",
                "会议价格(元)",
                "档期"
            ],
            picsList: [
                require("../../assets/img/venuedetail_img/1.png"),
                require("../../assets/img/venuedetail_img/2.png"),
                require("../../assets/img/venuedetail_img/3.png"),
                require("../../assets/img/venuedetail_img/4.png"),
                require("../../assets/img/venuedetail_img/5.png"),
                require("../../assets/img/venuedetail_img/6.png"),
                require("../../assets/img/venuedetail_img/7.png")
            ],
            currFieldName: "会议档期" // 当前的会议定期
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.todayDate = this.mtils.extention.formatDate(
            this.todayDate,
            "yyyy-MM-dd"
        );
        this.getDetailData();
    },
    watch: {},
    methods: {
        handleChange(val) {
            this.currActive = val;
        },
        /**
         * @description: 跳转到百度地图
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleToBaiduMap(info) {
            // console.log(info)
            window.open(
                `http://api.map.baidu.com/marker?location=${info.latitude},${info.longitude}&title=${info.storeName}&content=${info.address}&output=html`
            );
        },
        /**
         * @description: 获取会场详情
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getDetailData() {
            let params = {
                storeId: this.$route.query.id
            };
            this.$get("/api/v1/storeWebsite/desc", params)
                .then(res => {
                    if (res.code == 200) {
                        this.venueDetailData = res.data;
                        this.$nextTick(() => {
                            const swiperTop = this.$refs.swiperTop.$swiper;
                            const swiperThumbs = this.$refs.swiperThumbs
                                .$swiper;
                            swiperTop.controller.control = swiperThumbs;
                            swiperThumbs.controller.control = swiperTop;
                        });
                        this.venueDetailData.fieldList.map((item, index) => {
                            this.$set(item, "currStatus", false);
                            if (index === 0) {
                                item.currStatus = true;
                            }
                        });
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 获取对应类型
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getType(val) {
            switch (val) {
                case 1:
                    return "公共设施";
                    break;
                case 2:
                    return "通用设施";
                    break;
                case 3:
                    return "会议设施";
                    break;
                case 4:
                    return "特殊设施";
                    break;
                default:
                    "";
            }
        },
        /**
         * @description: 打开档期弹窗
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleOpenCalendar(item) {
            this.currFieldName = item.fieldName;
            this.getfileldDate(item.fieldId);
            this.isOpenCalendar = true;
        },
        /**
         * @description: 获取档期信息
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getfileldDate(fieldId) {
            this.$get("/api/v1/storeWebsite/day", { fieldId })
                .then(res => {
                    if (res.code == 200) {
                        this.fileldDate = res.data;
                        this.endDate = this.fileldDate.endDay;
                        if (this.fileldDate.updateAmount.length) {
                            this.fileldDate.updateAmount.map(item => {
                                if (
                                    item.amount * 1 <
                                    this.fileldDate.amount * 1
                                ) {
                                    this.cheapDateList.push(item.activeDate);
                                } else {
                                    this.hightDateList.push(item.activeDate);
                                }
                            });
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        /**
         * @description: 设置有效时间
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getShowDate(date, data) {
            const currTime = new Date(date);
            const endTime = new Date(this.endDate);
            const todayTime = new Date(Date.now() - 8.64e7);
            // 过去的时间显示'已过期'
            if (currTime < todayTime) {
                return "is_expire";
            } else if (currTime > todayTime && currTime <= endTime) {
                // 开放的时间是否已订
                if (
                    this.fileldDate.soldDay.length &&
                    this.fileldDate.soldDay.indexOf(data.day) !== -1
                ) {
                    return "is_order";
                    // 低价
                } else if (this.cheapDateList.indexOf(data.day) !== -1) {
                    return "is_cheap";
                    // 高价
                } else if (this.hightDateList.indexOf(data.day) !== -1) {
                    return "is_expensive";
                    // 正常价
                } else {
                    return "is_open";
                }
                // 未来的时间显示未开放
            } else if (currTime > endTime) {
                return "is_not_open";
            }
        },
        /**
         * @description: 是否是今天
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getToday(data) {
            if (this.todayDate === data.day) {
                return "今天";
            } else {
                return data.day.split("-")[2];
            }
        },
        /**
         * @description: 展示优惠价格
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getCheapPrice(data) {
            let amount = "";
            this.fileldDate.updateAmount.map(item => {
                if (item.activeDate === data.day) {
                    amount = item.amount;
                }
            });
            return amount;
        },
        /**
         * @description: 展示高价格
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        getHightPrice(data) {
            let amount = "";
            this.fileldDate.updateAmount.map(item => {
                if (item.activeDate === data.day) {
                    amount = item.amount;
                }
            });
            return amount;
        },
        /**
         * @description: 弹框关闭清除数据
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        cleanData() {
            this.hightDateList = [];
            this.cheapDateList = [];
            this.fileldDate = null;
            this.isOpenCalendar = false;
        }
    }
};
</script>

<style scoped lang="stylus">
.el-dialog__wrapper
    >>>.el-dialog__body
        padding 0
.el-calendar
    >>>.el-calendar__body
        padding 12px 20px 15px
    >>>.el-calendar-day
        padding 2px
        height 70px
.tips_box
    font-size 12px
.calendar_cell
    width 100%
    height 100%
    font-size 14px
    color #666
    display flex
    justify-content space-between
    span
        padding 4px
.is_today
    color #10baaa
    font-weight bold
.is_today_order
    color #fff
    font-weight bold
.expire_date
    background #eee
    .is_expire_date
        font-weight bold
        color #aaa
.open_date
    display flex
    flex-direction column
    align-items flex-end
    .is_open_desc
        color #666
    .is_open_date
        font-weight bold
        color #666
.expensive_data
    display flex
    flex-direction column
    align-items flex-end
    .is_expensive_desc
        color #666
    .is_expensive_date
        font-weight bold
        color #666
.order_date
    background #10baaa
    .is_order_desc
        color #fff
    .is_order_date
        color #fff
        font-weight bold
.not_open_date
    background #eee
    .is_not_open_desc
        font-weight bold
    .is_not_open_date
        font-weight bold
        color #aaa
.cheap_date
    width 100%
    height 100%
    font-size 14px
    color #666
    .cheap_box_top
        height 40%
        padding-right 4px
        display flex
        justify-content space-between
        .is_cheap_desc
            width 15px
            height 15px
            background url('../../assets/img/venuedetail_img/cheap.png') center center no-repeat
        .is_cheap_date
            font-weight bold
            color #666
    .cheap_box_bottom
        height 60%
        display flex
        flex-direction column
        justify-content flex-end
        align-items flex-end
        padding-right 4px
        .cheap_price
            color #666
        .cheap_num
            margin-top 4px
            font-size 12px
            color #10baaa
            i
                font-size 12px
.venue_detail_wrap
    width 1200px
    margin 0 auto
    .breadcrumb_wrap
        >>>.el-breadcrumb
            font-size 12px
        height 60px
        display flex
        align-items center
    .top_main_info
        display flex
        .swiper_wrap
            width 600px
            height 400px
            background-color #000
            .swiper
                .swiper-button-next::after, .swiper-button-prev::after
                    font-size 30px
                .swiper-slide
                    background-size cover
                    background-position center
                    .slide_big
                        width 100%
                        height 100%
                    .slide_small
                        width 150px
                        height 100px
                &.gallery-top
                    height 80%
                    width 100%
                &.gallery-thumbs
                    height 20%
                    box-sizing border-box
                    padding-top 2px
                &.gallery-thumbs .swiper-slide
                    width 25%
                    height 100%
                    opacity 0.4
                &.gallery-thumbs .swiper-slide-active
                    opacity 1
        .desc_info
            margin-left 50px
            width 550px
            .tags
                display flex
                align-items center
                .discount
                    width 35px
                    height 20px
                    padding 2px 0
                    line-height 20px
                    text-align center
                    border-radius 4px
                    background #FF5722
                    color #fff
                    font-size 12px
                    margin-right 4px
                .checked
                    width 72px
                    height 20px
                    padding 2px 0
                    line-height 20px
                    text-align center
                    border-radius 4px
                    font-size 12px
                    color #fff
                    background #10baaa
                    margin-right 4px
                .txt
                    font-size 24px
                    font-weight bold
                    margin-right 6px
                .unique
                    font-size 14px
                    color #ff5722
                    margin-bottom 2px
                    align-self flex-end
            .icons
                .list
                    display flex
                    border-bottom 1px solid #d5d5d5
                    .item
                        flex 1
                        .item_inner
                            display flex
                            padding 30px 0
                            flex-direction column
                            justify-content center
                            align-items center
                            .middle
                                margin-top 5px
                                font-weight bold
                                margin-bottom 10px
                            .last
                                color #666
                                font-size 12px
            .address_wrap
                display flex
                justify-content space-between
                font-size 12px
                padding 25px 0
                border-bottom 1px solid #d5d5d5
                .send, .address
                    display flex
                    align-items center
                    cursor pointer
                    img
                        margin-right 4px
                    .send_txt
                        color #10baaa
            .phone
                padding 23px 0
                display flex
                align-items center
                border-bottom 1px solid #d5d5d5
                .label
                    font-size 12px
                .value
                    color #FF5722
                    font-size 20px
            .special_tag
                padding 20px 0
                border-bottom 1px solid #d5d5d5
                .title
                    font-size 14px
                    font-weight bold
                .tag_list
                    margin-top 20px
                    .tag
                        border 1px solid #666
                        padding 4px 8px
                        border-radius 6px
                        margin-right 10px
                        font-size 12px
                        color #666
    .tabs_wrap
        width 100%
        margin-top 50px
        .list
            position -webkit-sticky
            position -moz-sticky
            position -ms-sticky
            position sticky
            background-color #fff
            top 88px
            z-index 888
            display flex
            width 100%
            border-bottom 1px solid #10baaa
            .item
                display flex
                cursor pointer
                a
                    color #000
                    padding 10px 20px
            .active
                background #10baaa
                transition all 0.28s ease-out
                a
                    color #fff
        #meeting_info_wrap
            .meeting_info
                margin 30px 0 17px 0
                border-left 4px solid #10baaa
                .title
                    font-weight bold
                    padding-left 10px
            .list_wrap
                .header
                    width 100%
                    display flex
                    align-items center
                    background #f6f6f6
                    .item
                        text-align center
                        font-size 14px
                        flex 1
                    .special
                        width 260px
                        height 55px
                        font-size 14px
                        display flex
                        flex-direction column
                        justify-content center
                        align-items center
                        .pics
                            margin-top 5px
                            display flex
                            justify-content center
                            .item
                                width 16px
                                height 16px
                                margin 0 10px
                .data_wrap
                    .swiper
                        .swiper-button-prev::after, .swiper-button-next::after
                            font-size 30px
                            color #ccc
                        >>>.swiper-pagination
                            .swiper-pagination-bullet-active
                                background #10baaa
                        .swiper-slide
                            display flex
                            align-items center
                            justify-content center
                            img
                                width 180px
                                height 120px
                    .col
                        width 100%
                        height 45px
                        display flex
                        align-items center
                        background #fff
                        .item
                            text-align center
                            font-size 14px
                            flex 1
                        .first, .last
                            cursor pointer
                            text-align left
                            font-weight bold
                        .special
                            width 260px
                            font-size 14px
                            display flex
                            flex-direction column
                            justify-content center
                            align-items center
                            .pics
                                width 100%
                                display flex
                                justify-content center
                                .item
                                    width 40px
                .load_rest
                    height 35px
                    background #F6F6F6
                    display flex
                    justify-content center
                    align-items center
                    span
                        font-size 14px
                        cursor pointer
                        color #10baaa
                        &:hover
                            color #ff5722
                            transition all 0.28s ease-out
        #meeting_introduct_wrap
            border-bottom 1px solid #ddd
            padding-bottom 20px
            .meeting_introduct
                margin 30px 0 17px 0
                border-left 4px solid #10baaa
                .title
                    font-weight bold
                    padding-left 10px
            .txt_box
                font-size 12px
                color #666
                position relative
                .txt
                    display block
                    text-indent 40px
                    line-height 25px
                    transition all 0.28s ease-out
                .position
                    cursor pointer
                    color #10baaa
                    position absolute
                    right 0
                    bottom 0
        #equipment_wrap
            padding-bottom 60px
            .equipment
                margin 20px 0 17px 0
                border-left 4px solid #10baaa
                .title
                    font-weight bold
                    padding-left 10px
            .list_wrap
                .list
                    display flex
                    flex-direction column
                    .item
                        display flex
                        flex-direction column
                        padding-bottom 10px
                        border-bottom 1px solid #ddd
                    &:last-child
                        border none
                        .title
                            color #000
                            font-weight bold
                            margin-top 10px
                            font-size 14px
                        .pic_list_wrap
                            .pic_list
                                display flex
                                flex-wrap wrap
                                .pic_item
                                    width 80px
                                    height 80px
                                    display flex
                                    flex-direction column
                                    justify-content center
                                    align-items center
                                    .pic
                                        width 30px
                                        height 30px
                                        margin-bottom 9px
                                    .name
                                        font-size 12px
                                        color #666
</style>        
